import React from 'react';

interface FieldErrorProps {
  id?: string;
  message?: string;
}

export const FieldError: React.FC<FieldErrorProps> = ({ id, message }) => {
  if (!message) return null;
  return (
    <p id={id} className="field-error" role="alert">
      {message}
    </p>
  );
};
